module.exports = __webpack_public_path__ + "static/media/homepage_top_section.1e9f15d4.png";